export default __webpack_public_path__ + "static/media/SignPost.b55475a6.png";